import axios from 'axios';
import { toast } from 'react-toastify';

let setIsLoading;

export const initializeAxios = (setLoadingFunction) => {
  setIsLoading = setLoadingFunction;
};

const axiosInstance = axios.create({
  baseURL: 'https://api.sriraminternationalhomestay.com/',
  // baseURL: 'http://localhost:5001/',
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (setIsLoading) setIsLoading(true);
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    if (setIsLoading) setIsLoading(false);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (setIsLoading) setIsLoading(false);
    return response;
  },
  (error) => {
    console.error('Response error:', error);
    if (setIsLoading) setIsLoading(false);

    let errorMessage = 'An unexpected error occurred';

    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMessage = error.response.data.message || 'Bad Request';
          toast.error(errorMessage);
          break;
        case 401:
          errorMessage = error.response.data.message || 'Unauthorized. Please log in again.';
          toast.error(errorMessage);

          localStorage.clear();
          window.location.reload();
          break;
        case 403:
          errorMessage = error.response.data.message || 'Forbidden. You do not have permission to access this resource.';
          toast.error(errorMessage);
          break;
        case 404:
          errorMessage = error.response.data.message || 'Resource not found';
          break;
        case 500:
          errorMessage = error.response.data.message || 'Internal Server Error. Please try again later.';
          break;
        default:
          errorMessage = error.response.data.message || `Error: ${error.response.status}`;
          toast.error(errorMessage);
      }
    } else if (error.request) {
      errorMessage = 'No response received from server. Please check your internet connection.';
    }

    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

    return Promise.reject(error);
  }
);

export default axiosInstance;